export var RED = '#ed0000';
export var LORDAGSGODIS = RED;
export var RUBBET = RED;
export var RED_CORPORATE_BRAND = '#ff0000';
export var RED_100 = '#ffeceb';
export var BLACK = '#000000';
export var SKRAPSPEL = BLACK;
export var WHITE = '#ffffff';
export var YELLOW = '#ffbb00';
export var GREEN = '#008912';
export var BLUE = '#256FEA';
export var NAVY = '#001932';
export var NAVY_700 = '#4D5E70';
export var ORANGE = '#ff5500';
export var COMMUNICATION_BLUE = '#91c5d5';
export var COMMUNICATION_GREEN = '#b1cc8a';
export var DATA_PRIMARY_TUR = '#BFF1BF';
export var DATA_SECONDARY_TUR = '#00D773';
export var DATA_PRIMARY_SPORT = '#8EF0FF';
export var DATA_SECONDARY_SPORT = '#00BEFA';
export var DATA_01 = '#001932';
export var DATA_02 = '#FA50A5';
export var DATA_03 = '#FF4D00';
export var DATA_04 = '#ED0000';
export var DATA_05 = '#9664FF';
export var DATA_06 = '#0000F5';
export var DATA_07 = '#00AB5C';
export var DATA_08 = '#0998FF';
export var DATA_09 = '#124600';
export var DATA_10 = '#008912';
export var DATA_11 = '#FF6109';
export var DATA_12 = '#6218FF';
export var DATA_13 = '#E150FD';
export var DATA_14 = '#003569';
export var DATA_15 = '#5E0097';
export var GREY_800 = '#252526';
export var GREY_700 = '#323233';
export var GREY_600 = '#4b4b4d';
export var GREY_500 = '#7d7d80';
export var GREY_400 = '#afafb3';
export var GREY_330 = '#d4d4d9';
export var GREY_300 = '#e1e1e5';
export var GREY_200 = '#ededf2';
export var GREY_100 = '#fafaff';
export var NAVIGATION_700 = '#3e3e40';
export var NAVIGATION_500 = '#646466';
export var OPACITY_10 = '#000000';
export var OPACITY_20 = '#000000';
export var OPACITY_30 = '#000000';
export var OPACITY_40 = '#000000';
export var OPACITY_60 = '#000000';
export var OPACITY_80 = '#000000';
export var OPACITY_WHITE_10 = '#ffffff';
export var OPACITY_WHITE_20 = '#ffffff';
export var OPACITY_WHITE_30 = '#ffffff';
export var OPACITY_WHITE_40 = '#ffffff';
export var OPACITY_WHITE_60 = '#ffffff';
export var OPACITY_WHITE_80 = '#ffffff';
export var SPORT = '#00befa';
export var SPORT_50 = '#f1f6f7';
export var SPORT_100 = '#D9FDFF';
export var SPORT_200 = '#c3fbff';
export var SPORT_400 = '#e5eff2';
export var SPORT_800 = '#004257';
export var SPORT_900 = '#596d7f';
export var CASINO_CATEGORY_100 = '#F4AA51';
export var CASINO_CATEGORY_200 = '#9E11A2';
export var CASINO_CATEGORY_300 = '#D9438A';
export var CASINO_CATEGORY_400 = '#20CCBA';
export var CASINO_CATEGORY_500 = '#1D2F6F';
export var CASINO_CATEGORY_600 = '#8490FA';
export var CASINO_CATEGORY_700 = '#32C5FF';
export var CASINO_CATEGORY_800 = '#49116A';
export var CASINO_CATEGORY_900 = '#1E796D';
export var CASINO_CATEGORY_1000 = '#E794B4';
export var CASINO_LIVE_CATEGORY_100 = '#ED5B93';
export var CASINO_LIVE_CATEGORY_200 = '#5E0D70';
export var CASINO_LIVE_CATEGORY_300 = '#C1264F';
export var CASINO_LIVE_CATEGORY_400 = '#0B2D4F';
export var CASINO_LIVE_CATEGORY_500 = '#00584B';
export var CASINO_LIVE_CATEGORY_600 = '#2C39A4';
export var CASINO_LIVE_CATEGORY_700 = '#820059';
export var CASINO_LIVE_CATEGORY_800 = '#00919C';
export var CASINO_LIVE_CATEGORY_900 = '#2196C4';
export var CASINO_LIVE_CATEGORY_1000 = '#3C0A7A';
export var CASINO = '#FF80A4';
export var CASINO_1100 = '#00132F';
export var CASINO_1000 = '#001932';
export var CASINO_900 = '#0000BB';
export var CASINO_800 = '#0047AF';
export var CASINO_700 = '#7400BB';
export var CASINO_600 = '#FF3B78';
export var CASINO_500 = '#E83178';
export var CASINO_400 = '#FF4E8F';
export var CASINO_300 = '#FF3D7B';
export var CASINO_200 = '#DC5C80';
export var CASINO_100 = '#FFDBDB';
export var CHALLENGE = '#55042a';
export var CHALLENGE_700 = CHALLENGE;
export var CHALLENGE_600 = CHALLENGE;
export var CHALLENGE_500 = CHALLENGE;
export var CHALLENGE_400 = CHALLENGE;
export var CHALLENGE_300 = CHALLENGE;
export var CHALLENGE_200 = CHALLENGE;
export var CHALLENGE_100 = '#e60000';
export var COMPETITION = '#2C5489';
export var COMPETITION_800 = '#80A0BC';
export var COMPETITION_700 = '#95ABC4';
export var COMPETITION_600 = '#D5E3EF';
export var COMPETITION_500 = '#403523';
export var COMPETITION_400 = '#B09054';
export var COMPETITION_300 = '#DFB76B';
export var COMPETITION_200 = '#E7CB95';
export var COMPETITION_100 = '#FFE9BF';
export var EUROPATIPSET = '#008733';
export var EUROPATIPSET_700 = '#003314';
export var EUROPATIPSET_600 = '#004018';
export var EUROPATIPSET_500 = '#004d1d';
export var EUROPATIPSET_300 = '#00732b';
export var EUROPATIPSET_200 = '#1a8044';
export var EUROPATIPSET_100 = '#00a13e';
export var EXTRATIPSET = '#0069a8';
export var EXTRATIPSET_700 = '#005384';
export var EXTRATIPSET_600 = '#005384';
export var EXTRATIPSET_500 = '#0069a8';
export var EXTRATIPSET_300 = '#0069a8';
export var EXTRATIPSET_200 = '#ffda05';
export var EXTRATIPSET_100 = '#0069a8';
export var FULLTRAFF = '#660099';
export var FULLTRAFF_900 = '#66ff99';
export var FULLTRAFF_800 = '#ff6d03';
export var FULLTRAFF_700 = '#ff00ff';
export var FULLTRAFF_400 = '#330033';
export var FULLTRAFF_300 = '#3b0158';
export var FULLTRAFF_1200 = '#b280cc';
export var FULLTRAFF_1000 = '#D1B2E0';
export var FULLTRAFF_500 = '#E8D8EF';
export var FULLTRAFF_200 = '#F6F0F9';
export var FULLTRAFF_100 = '#FAF7FC';
export var MALTIPSET = '#b5c6e2';
export var MALTIPSET_800 = '#a1afc8';
export var MALTIPSET_700 = '#284163';
export var MALTIPSET_600 = '#324764';
export var MALTIPSET_500 = '#364d6e';
export var MALTIPSET_400 = '#3e587d';
export var MALTIPSET_300 = '#0063b7';
export var MALTIPSET_200 = '#cce0ff';
export var MALTIPSET_100 = '#4481e3';
export var MALTIPSET_950 = '#111111';
export var MOMANG = '';
export var ODDSET = '#e60000';
export var BOMBEN = ODDSET;
export var MATCHEN = ODDSET;
export var POWERPLAY = ODDSET;
export var ODDSET_HEADER = '#a00813';
export var ODDSET_700 = '#570b04';
export var ODDSET_600 = '#770F05';
export var ODDSET_500 = '#8a1207';
export var ODDSET_400 = '#9d1407';
export var ODDSET_300 = '#cc0000';
export var ODDSET_GREY_80 = '#7a7a7a';
export var ODDSET_200 = '#ed242a';
export var PNP = '#6E14EB';
export var PNP_100 = '#1E1E33';
export var PNP_200 = '#5519B0';
export var PNP_300 = '#8B43EF';
export var PNP_400 = '#9E29FF';
export var PNP_500 = '#A872F3';
export var PNP_600 = '#C5A1F7';
export var PNP_700 = '#E2D0FB';
export var PNP_800 = '#2A2A40';
export var PNP_900 = '#FFA800';
export var PNP_1000 = '#1CFFF3';
export var POKER_100 = '#23585F';
export var POKER_200 = '#317A84';
export var POKER_300 = '#47ADBB';
export var POKER_400 = '#4ED8E9';
export var POKER_500 = '#CEF8FF';
export var POKER_600 = '#100F10';
export var POKER_700 = '#FAA719';
export var POKER_800 = '#3E3D3E';
export var POKER_900 = '#FFFFFF';
export var POKER_GRADIENT_LIGHT = '';
export var POKER_GRADIENT_DARK = '';
export var RACING = '#00a88b';
export var TRAV_GALOPP = RACING;
export var RACING_100 = '#056353';
export var RACING_200 = '#F7F9F9';
export var RACING_900 = '#596D7F';
export var RACING_300 = '#e3e4de';
export var RACING_400 = '#c7e9e3';
export var RACING_500 = '#004a3d';
export var SPORTSERVICE = '#000000';
export var SPORTSERVICE_700 = '#2d2d2e';
export var SPORTSERVICE_400 = '#5e5e5e';
export var SPORTSERVICE_300 = '#858585';
export var SPORT_LIVE = '#4cacff';
export var SPORTSERVICE_ORANGE = '#ff5500';
export var STRYKTIPSET = '#00427a';
export var STRYKTIPSET_800 = '#e60000';
export var STRYKTIPSET_700 = '#052038';
export var STRYKTIPSET_600 = '#273c4d';
export var STRYKTIPSET_500 = '#072f52';
export var STRYKTIPSET_400 = '#466c8b';
export var STRYKTIPSET_300 = '#0063b7';
export var STRYKTIPSET_200 = '#0063b7';
export var STRYKTIPSET_100 = '#0073ff';
export var STRYKTIPSET_BANNER = '#4F6CA9';
export var SYNDICATE_300 = '#0073ff';
export var SYNDICATE_200 = '#0073ff';
export var SYNDICATE_PROMO = '#00D773';
export var SYNDICATE = '#000000';
export var TIPS_SM = '#0066a4';
export var TOPPTIPSET = '#f29400';
export var TOPPTIPSET_700 = '#593700';
export var TOPPTIPSET_600 = '#663300';
export var TOPPTIPSET_500 = '#8c4600';
export var TOPPTIPSET_400 = '#a16300';
export var TOPPTIPSET_300 = '#bf6000';
export var TOPPTIPSET_200 = '#d98e16';
export var TOPPTIPSET_100 = '#ffa826';
export var ANDRA_CHANSEN = '#003800';
export var ANDRA_CHANSEN_GREEN = ANDRA_CHANSEN;
export var ANDRA_CHANSEN_GOLD = '#A58A31';
export var ANDRA_CHANSEN_100 = ANDRA_CHANSEN_GOLD;
export var TUR = '#00d773';
export var TUR_100 = '#eafbe5';
export var TUR_200 = '#e7f6d0';
export var BINGO = '#c91485';
export var BINGO_200 = '#a60369';
export var BINGO_300 = '#a60369';
export var BINGO_500 = '#a60369';
export var BINGO_700 = '#a60369';
export var EUROJACKPOT = '#A83001';
export var EUROJACKPOT_100 = '#6F0900';
export var EUROJACKPOT_200 = '#E15702';
export var EUROJACKPOT_300 = '';
export var EUROJACKPOT_400 = '#FF4F0A';
export var EUROJACKPOT_500 = '#FFCDAB';
export var EUROJACKPOT_600 = '#FFED00';
export var FLER_LOTTER = '#7800FF';
export var FLER_LOTTER_100 = '#B12BFF';
export var FLER_LOTTER_200 = '#F7F9A8';
export var GAME_PACKAGES = '#b50f0f';
export var GAME_PACKAGES_100 = '#7f0000';
export var JOKER = '#b50f0f';
export var JOKER_100 = '#7f0000';
export var JOKER_300 = JOKER_100;
export var JOKER_400 = JOKER_100;
export var JOKER_200 = '#ed0000';
export var KENO = '#ffdd00';
export var KENO_100 = '#ffc600';
export var KENO_250 = KENO_100;
export var KENO_200 = '#ffee00';
export var KENO_300 = '#ed0000';
export var KENO_400 = KENO_300;
export var KENOXPRESS = '#ffdd00';
export var KENOXPRESS_100 = '#ffc600';
export var KENOXPRESS_200 = '#ffee00';
export var KENOXPRESS_250 = KENOXPRESS_200;
export var KENOXPRESS_300 = '#ed0000';
export var LOTTO = '#005400';
export var LOTTO_100 = '#003800';
export var LOTTO_600 = LOTTO_100;
export var LOTTO_200 = '#108a0b';
export var LOTTO_500 = LOTTO_200;
export var LOTTO_400 = LOTTO_200;
export var LOTTO_300 = '#55ff33';
export var SKRAPSPEL_SKRAPKRYSS = '#DD6B10';
export var SKRAP_KRYSS = SKRAPSPEL_SKRAPKRYSS;
export var SKRAPSPEL_SKRAPKRYSS_100 = '#E8C6AB';
export var SKRAPSPEL_SKRAPMATCHA = '#DEADD0';
export var SKRAPSPEL_SKRAPBINGO = '#ABD8E8';
export var SKRAP_BINGO = SKRAPSPEL_SKRAPBINGO;
export var SKRAPSPEL_SKRAPKENO = '#fcd124';
export var SKRAPSPEL_SKRAP7AN = '#00AB96';
export var SKRAP7AN = SKRAPSPEL_SKRAP7AN;
export var SKRAPSPEL_SECONDARY = '#3C3C3B';
export var SMASPEL_17ELLERMER = '#b31472';
export var SMASPEL_3IRAD = '#377b8f';
export var SMASPEL_MITTEMELLAN = '#b91212';
export var SUPPORTERN = '#001932';
export var SUPPORTERN_200 = '#0D3A62';
export var TRISS = '#ffed00';
export var TRISS_500 = '#d0a026';
export var TRISS_300 = '#ffba00';
export var TRISS_200 = '#ffd118';
export var TRISS_100 = '#fff34c';
export var VIKINGLOTTO = '#0000ff';
export var VIKINGLOTTO_100 = '#000099';
export var VIKINGLOTTO_200 = '#6161ff';
export var VIKINGLOTTO_GAME_BACKGROUND = VIKINGLOTTO_200;
export var VIKINGLOTTO_20 = VIKINGLOTTO_200;
export var VIKINGLOTTO_30 = VIKINGLOTTO_200;
export var VIKINGLOTTO_300 = '#e5007f';
export var VIKINGLOTTO_SECONDARY = VIKINGLOTTO_300;